module.exports = __webpack_public_path__ + "static/media/4ODA18.707162d6.jpg";